export const colors = 
{
    teal: {
        name: 'teal',
        hex: '#007f7f'
    },
    orange: {
        name: 'orange',
        hex: '#b54800'
    },
    grey: {
        name: null,
        hex: '#d4d4d5'
    }
}

export const styles = {
    primary: {
      color: 'orange',
      bgColor: 'honeydew'
    },
    secondary: {
      color: 'grey',
      bgColor: '#f4f4f4'
    }
  };